export default {
  name: 'ChipList',
  displayName: {
    en: 'Tag List',
    ja: 'タグリスト',
  },
  icon: './icon.png',
  defaultWidth: 375,
  defaultHeight: 528,
  resizeX: true,
  props: [
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
    },
    {
      name: 'sortList',
      displayName: {
        en: 'Sorting',
        ja: '並び替え',
      },
      type: 'sort',
    },
    {
      name: 'maximumItems',
      displayName: {
        en: 'Maximum number of items',
        ja: '上限',
      },
      type: 'maximumItems',
    },
    {
      name: 'columnCount',
      displayName: {
        en: 'Columns',
        ja: '列',
      },
      type: 'number',
      default: 1,
      control: {
        type: 'menu',
        options: [
          {
            label: '1',
            value: 1,
          },
          {
            label: '2',
            value: 2,
          },
          {
            label: '3',
            value: 3,
          },
          {
            label: '4',
            value: 4,
          },
        ],
      },
      enabled: {
        horizontalScroll: false,
      },
    },
    {
      name: 'onPress',
      displayName: {
        en: 'Tag',
        ja: 'タグ',
      },
      type: 'action',
      role: 'listItem',
      reference: 'items',
    },
  ],
  childComponents: [
    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      role: 'listItem',
      reference: 'items',
      style: {
        text: { textAlign: false, lineHeight: false, fontStyle: false },
        color: '@text',
        'selected.color': {
          displayName: {
            en: 'Text color: selected',
            ja: '塗り: 選択時',
          },
        },
      },
      props: [
        {
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          default: 'Title',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          name: 'titleLineNum',
          displayName: {
            en: 'Number of Lines',
            ja: '行数',
          },
          type: 'number',
          default: 1,
          control: {
            type: 'menu',
            options: [
              {
                label: 'canvas.menuRight.elementTab.list.singleLine',
                value: 1,
              },
              {
                label: 'canvas.menuRight.elementTab.list.multiLine',
                value: 2,
              },
            ],
          },
        },
      ],
    },
    {
      displayName: {
        en: 'Image',
        ja: '画像',
      },
      name: 'cardCover',
      role: 'listItem',
      reference: 'items',
      style: {
        border: true,
        borderRadius: 16,
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'image',
          displayName: {
            en: 'Image Source',
            ja: '画像ソース',
          },
          type: 'image',
        },
      ],
    },
    {
      name: 'closeIcon',
      displayName: {
        en: 'Close Icon',
        ja: 'クローズアイコン',
      },
      role: 'listItem',
      reference: 'items',
      style: {
        iconColor: true,
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'iconType',
          displayName: {
            en: 'Type',
            ja: 'タイプ',
          },
          type: 'text',
          default: 'icon',
          control: {
            type: 'menu',
            options: [
              {
                label: 'Icon',
                value: 'icon',
              },
              {
                label: 'Toggle',
                value: 'toggle',
              },
            ],
          },
        },
        {
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          name: 'icon',
          type: 'icon',
          default: 'close-circle',
          enabled: {
            iconType: ['icon', 'toggle'],
          },
        },
        {
          name: 'onPress',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
          type: 'action',
          enabled: {
            iconType: ['icon', 'toggle'],
          },
        },
      ],
    },
  ],
  // tag list style (全体スタイル)
  style: {
    opacity: true,
    gap: {
      displayName: {
        en: 'Item gap',
        ja: 'アイテムギャップ',
      },
      default: 8,
    },
    'tag.height': {
      displayName: {
        en: 'Tag Size',
        ja: 'タグサイズ',
      },
    },
    'tag.backgroundColor': {
      displayName: {
        en: 'Tag background color',
        ja: 'タグ背景色',
      },
    },
    'tag.selected.backgroundColor': {
      displayName: {
        en: 'Tag background color:selected',
        ja: 'タグ背景色: 選択時',
      },
    },
    'tag.border': {
      displayName: {
        en: 'Tag border',
        ja: 'タグ枠線',
      },
    },
    'tag.borderRadius': {
      displayName: {
        en: 'Tag border radius',
        ja: 'タグ角丸',
      },
    },
    'tag.shadow': {
      displayName: {
        en: 'Tag shadow',
        ja: 'タグシャドー',
      },
    },
  },
};
